import { render } from "./ExhibitorAddPage.vue?vue&type=template&id=45ad61d3&scoped=true"
import script from "./ExhibitorAddPage.vue?vue&type=script&lang=js"
export * from "./ExhibitorAddPage.vue?vue&type=script&lang=js"

import "./ExhibitorAddPage.vue?vue&type=style&index=0&id=45ad61d3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ad61d3"]])

export default __exports__